import { render, staticRenderFns } from "./editOrganizationModal.vue?vue&type=template&id=38ec7688&scoped=true"
import script from "./editOrganizationModal.vue?vue&type=script&lang=js"
export * from "./editOrganizationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec7688",
  null
  
)

export default component.exports